import { render, staticRenderFns } from "./RoundsOfRewardsItems.vue?vue&type=template&id=5b6fe03a&scoped=true&"
import script from "./RoundsOfRewardsItems.vue?vue&type=script&lang=js&"
export * from "./RoundsOfRewardsItems.vue?vue&type=script&lang=js&"
import style0 from "./RoundsOfRewardsItems.vue?vue&type=style&index=0&id=5b6fe03a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6fe03a",
  null
  
)

export default component.exports